<script>
import userApi from '@/api/user';
import contactApi from '@/api/contact';
import referralApi from '@/api/referral';
import payoutApi from '@/api/payout';

import userModel from '@/model/user';

import DefaultLayout from '@/layouts/Default.vue';
import UserDetailLayout from '../../components/user/UserDetailLayout.vue';

export default {
  name: 'UserDetailSelfPage',
  components: { DefaultLayout, UserDetailLayout },
  data() {
    return {
      additionalInfo: {},
    };
  },
  mounted() {
    this.fetchAdditionalInfo();
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async fetchAdditionalInfo() {
      const promisesByCategory = {
        contacts: contactApi.fetchList(),
        referrals: referralApi.fetchList(),
        payouts: payoutApi.fetchList(),
      };

      const promises = Object.values(promisesByCategory);
      const keys = Object.keys(promisesByCategory);
      const data = await Promise.all(promises);

      data.forEach((value, index) => {
        this.additionalInfo[keys[index]] = value?.items;
      });
    },

    async onUpdate(event) {
      const eventToUpdate = { ...event };

      if (event.tariff) {
        eventToUpdate.tariff = event.tariff['@id'];
      }

      await userApi.update(this.user.id, eventToUpdate);
      await userModel.fetchSelf();
    },

    async deleteContact(event) {
      const question = 'Вы действительно хотите удалить контакт?';
      const result = await this.$confirm(question);

      if (result) {
        await contactApi.delete(event);
        await userModel.fetchSelf();
        this.$push({ text: 'Контакт успешно удалён' });
      }
    },
  },
};
</script>

<template lang="pug">
  DefaultLayout(v-if="user && additionalInfo")
    UserDetailLayout(
      :user="user"
      :additionalInfo="additionalInfo"
      :tab="$route.params.tab"
      @update="onUpdate"
      @changeTab="$router.push({ params: { tab: $event } })"
      @goToTariffs="$router.push({ name: $event })"
      @deleteContact="deleteContact"
      )
</template>

<style scoped lang="scss">

</style>
